import React, { MouseEventHandler } from 'react';
import { Box, Button, Text } from '@doda/io-react/common';
import styles from './index.module.scss';

/**
 * NoResultコンポーネントのProps
 */
export interface Props {
  /** ボタンのリンク先URL */
  href: string;
  /** クリックイベントのハンドラー（任意） */
  onClick?: MouseEventHandler<HTMLAnchorElement>;
}

/**
 * NoResultコンポーネント
 * 検索結果が0件の場合の表示
 * @param {Props} props - コンポーネントのプロパティ
 * @returns {JSX.Element} NoResultのJSX要素
 */
export const NoResult: React.FC<Props> = ({ href, onClick }) => {
  return (
    <Box border="red" className={styles.noResult__wrapper}>
      <Text
        size="20"
        weight="bold"
        color="red_pc"
        style={{ marginBottom: '8px' }}
      >
        この条件にあった求人は0件です。
      </Text>
      <Text
        size="14--articlePC"
        color="black_pc"
        weight="bold"
        style={{ marginBottom: '16px' }}
      >
        ほかにも希望する条件で検索してみましょう
      </Text>
      <Button
        as="a"
        href={href}
        onClick={onClick}
        variant="green"
        size="L"
        style={{ textDecoration: 'none' }}
      >
        検索条件を変更する
      </Button>
    </Box>
  );
};
